import Button from '@rio-cloud/rio-uikit/Button';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import { getLocale } from '../../../configuration';
import type { RootState } from '../../../configuration/setup/store';
import { getLocalizedOpenMarketplaceLink } from '../config/productConfig';
import { getTenant, Tenant } from './utils/tenants';

const ServiceBookButton = ({ locale, tenant }: { locale: string; tenant: Tenant }) => {
    const marketplaceLink = getLocalizedOpenMarketplaceLink(locale);

    // For these tenants, there is no functional TYPO3 Marketplace, so hide it
    if (!tenant || tenant === Tenant.SOUTH_KOREA || tenant === Tenant.SOUTH_AFRICA) {
        return null;
    }

    return (
        <Button
            as='a'
            className={'btn btn-default'}
            href={marketplaceLink}
            target='_blank'
            rel='noopener noreferrer'
            autoTrackingKey='marketplace.exploreServices'
        >
            <span className='uikit-icon icon-shopping-cart' aria-hidden='true' />
            <FormattedMessage id='marketplace.exploreServices' />
        </Button>
    );
};

const mapStateToProps = (state: RootState) => ({
    locale: getLocale(state),
    tenant: getTenant(state),
});

export const ServiceBookButtonContainer = connect(mapStateToProps)(ServiceBookButton);
